import React, { useState, useEffect } from 'react';
import { Box, IconButton, Button } from '@mui/material';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import DeleteIcon from '@mui/icons-material/Delete';

const ImageDragAndDrop = ({ image, setImage }) => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleDragOver = (e) => {
      e.preventDefault();
      e.dataTransfer.dropEffect = 'copy';
      setIsDragging(true);
    };

    const handleDragEnter = (e) => {
      e.preventDefault();
      setIsDragging(true);
    };

    const handleDragLeave = (e) => {
      e.preventDefault();
      setIsDragging(false);
    };

    const handleDrop = (e) => {
      e.preventDefault();
      setIsDragging(false);
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        const reader = new FileReader();
        reader.onloadend = () => {
          setImage(reader.result);
        };
        reader.readAsDataURL(files[0]);
      }
    };

    document.addEventListener('dragover', handleDragOver);
    document.addEventListener('dragenter', handleDragEnter);
    document.addEventListener('dragleave', handleDragLeave);
    document.addEventListener('drop', handleDrop);

    return () => {
      document.removeEventListener('dragover', handleDragOver);
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragleave', handleDragLeave);
      document.removeEventListener('drop', handleDrop);
    };
  }, [setImage]); // Se quita 'image' y se deja 'setImage'

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedImages = image;
    const [movedImage] = reorderedImages.splice(result.source.index, 1);
    reorderedImages.splice(result.destination.index, 0, movedImage);

    setImage(reorderedImages);
  };

  return (
    <Box sx={{ position: 'relative' }}>
      {isDragging && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#fff',
            fontSize: '2rem',
            pointerEvents: 'none',
          }}
        >
          Suelta la imagen para subirla
        </Box>
      )}
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable droppableId="image">
          {(provided) => (
            <Box
              {...provided.droppableProps}
              ref={provided.innerRef}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                mt: 2,
              }}
            >
              {image ?
                <Draggable key="1" draggableId="1" index={1}>
                  {(provided) => (
                    <Box
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      sx={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        p: 2,
                        border: '1px solid #ddd',
                        borderRadius: 2,
                        backgroundColor: '#f9f9f9',
                      }}
                    >
                      <img
                        src={image}
                        alt={`Uploaded preview ${1}`}
                        style={{ maxHeight: '100px', marginRight: '10px' }}
                      />
                      <IconButton onClick={() => setImage(null)}>
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  )}
                </Draggable>
                :
                ""
              }
              {provided.placeholder}
            </Box>
          )}
        </Droppable>
      </DragDropContext>
      <Button
        variant="contained"
        component="label"
        sx={{ mt: 2 }}
      >
        Subir Imagen
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={(e) => {
            if (e.target.files[0]) {
              const reader = new FileReader();
              reader.onloadend = () => {
                setImage(reader.result);
              };
              reader.readAsDataURL(e.target.files[0]);
            }
          }}
        />
      </Button>
    </Box>
  );
};

export default ImageDragAndDrop;
